import styled, { css } from 'styled-components';

export const YoutubeIframe = styled.div(
  () => css`
    > iframe {
      width: 100%;
      aspect-ratio: 16/9;
    }
  `,
);
